<template>
  <div>
    <h3 class="text-white">{{ current_palette_short_description }}</h3>
    <h5 class="text-white">{{ current_palette_full_description }}</h5>
    <!-- Leave the commented below line (used for additional infos if needed) -->
    <!-- <h5 align="right">{{ current_palette_short_name }}</h5> -->
  </div>
</template>

<i18n>
{
  "en": {
    "coming_soon": "Coming soon..."
  },
  "fr": {
    "coming_soon": "Bientôt disponible..."
  }
}
</i18n>

<script>
import _ from 'lodash'

import {
  short_tooltip_description_from_name,
  full_tooltip_description_from_name,
  disabled_brick_types,
} from './workflow_common.js'

// *****************************************************************************

export default {
  name: 'WorkflowPaletteDescription',
  props: ['workflow_interface'],
  data() {
    let res = {
      uid: _.uniqueId('uniqueid'),
    }
    return res
  },
  computed: {
    // current_palette_short_description() {
    //   let res = ''
    //   if (this.workflow_interface.tooltip) {
    //     res = this.$t(
    //       short_tooltip_description_from_name(
    //         this.workflow_interface.tooltip.name
    //       )
    //     )
    //   }

    //   return res
    // },
    // current_palette_full_description() {
    //   let res = ''
    //   if (this.workflow_interface.tooltip) {
    //     if (
    //       _.indexOf(
    //         disabled_brick_types,
    //         this.workflow_interface.tooltip.name
    //       ) !== -1
    //     ) {
    //       res = this.$t('coming_soon')
    //     } else {
    //       res = this.$t(
    //         full_tooltip_description_from_name(
    //           this.workflow_interface.tooltip.name
    //         )
    //       )
    //     }
    //   }
    //   return res
    // },
    current_palette_short_description() {
      let res = ''
      if (this.workflow_interface.tooltip) {
        res = short_tooltip_description_from_name(
          this.workflow_interface.tooltip.name
        )
      }

      return res
    },
    current_palette_full_description() {
      let res = ''
      if (this.workflow_interface.tooltip) {
        if (
          _.indexOf(
            disabled_brick_types,
            this.workflow_interface.tooltip.name
          ) !== -1
        ) {
          res = this.$t('coming_soon')
        } else {
          res = full_tooltip_description_from_name(
            this.workflow_interface.tooltip.name
          )
        }
      }
      return res
    },
    current_palette_short_name() {
      let res = 'brick'
      return res
    },
  },
}
</script>
